import React, { useState, useEffect } from 'react';
import { Game, Match } from '../../types/types';
import _ from 'underscore';
import PlayerGameCard from '../Cards/PlayerGameCard';
import { Paper, Select, MenuItem, InputLabel} from '@mui/material';
import styled from '@emotion/styled';
import { SelectChangeEvent } from '@mui/material/Select';
import { FILTERITEMS } from '../../globals/Globals';
export interface Props {
    singlematch: Match
}

const HIDEIF = [
    'points', 
    'minutes_played', 
    'base_points'
]

const SingleMatchTop = ({singlematch}:Props) => {
    const [ topGames, setTopGames ] = useState<Game[]>([]);
    const [ filterItem, setFilterItem] = useState("points");

    useEffect(() => {
        GetTop();
    }, [ singlematch, filterItem ]);

    function GetTop() {
        if (singlematch.games) {

        
            let games:Game[] = singlematch.games.slice();
            let top = _.chain(games).sortBy(function(game) {
                return -game[filterItem]
            }).value();
            setTopGames(top);
        }
    }

    let repeatlength:number = 5;

    
    const GridContainer = styled.div`
        margin-top: 6rem;
        display: grid;
        overflow-x: scroll;
        grid-template-rows: auto auto; 
        grid-auto-flow: column;
        grid-template-columns: repeat(${repeatlength},220px);
        grid-row-gap: 1rem;
        padding-bottom: 1rem;
        padding-left: 0.5rem;
        @media (min-width: 1024px) {
            grid-template-columns: repeat(${repeatlength},220px);
        }
    `;

    function onChange(changeevent:SelectChangeEvent<string>) {
        let newvalue = changeevent.target.value;
        if (!Array.isArray(newvalue)) {
            setFilterItem(changeevent.target.value);
        }
    }

    return (<Paper style={{display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0.5rem", marginBottom: "0.5rem", marginTop: "0.5rem", width: "100%", overflow: "scroll", position: "relative"}} elevation={5}>
        <div style={{position: "sticky", top: '0rem', left: "0.5rem", height: "3rem", textAlign: "left"}}>
            <p style={{marginBottom: 0}}>Top Players</p>
            <div style={{marginTop: "1rem", marginBottom: "1rem"}}>
                <InputLabel id={`sortbylabel`}>Sort By</InputLabel>
                <Select
                    value={filterItem}
                    onChange={onChange}
                    label={"Sort By"}
                    labelId={`sortbylabel`}
                    style={{width: 250, textAlign: "left", textTransform: 'capitalize'}}
                >
                    {FILTERITEMS.map(function(option) {
                        return <MenuItem value={option}>{option.split("_").join(" ")}</MenuItem>
                    })}
                </Select>
            </div>
        </div>
        <GridContainer>
            {topGames.map(function(game, index) {
                if (index < 14) {
                    return <div style={{marginRight: "1rem"}}>
                        <PlayerGameCard Game={game} filteritem={HIDEIF.includes(filterItem) ? undefined : filterItem} />
                    </div>
                }
            })}
        </GridContainer>
        
    </Paper>)

}

export default SingleMatchTop;